module.exports = __webpack_public_path__ + "static/media/entrance.ffa0557d.jpg";